import { Button, ButtonProps } from "@/components/ui/button";
import { useDemoModal } from "@/contexts/DemoModalContext";
import { cn } from "@/lib/utils";

interface RequestDemoButtonProps extends ButtonProps {
  label?: string;
  tracking?: {
    source?: string;
    campaign?: string;
    medium?: string;
  };
}

const RequestDemoButton = ({ 
  label = "Request Demo",
  tracking,
  className,
  children,
  ...props 
}: RequestDemoButtonProps) => {
  const { openDemoModal } = useDemoModal();

  const handleClick = () => {
    // Add tracking parameters if provided
    if (tracking) {
      const params = new URLSearchParams(window.location.search);
      Object.entries(tracking).forEach(([key, value]) => {
        if (value) params.set(key, value);
      });
      window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
    }
    
    openDemoModal();
  };

  return (
    <Button 
      onClick={handleClick}
      className={cn(
        "inline-flex items-center justify-center font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
        className
      )}
      aria-label="Request a product demo"
      {...props}
    >
      {children || label}
    </Button>
  );
};

export default RequestDemoButton;